import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const AvatarMenuItemWrapper = styled(Box)`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey_5};
  }
`
